import React from 'react';
import { Smartphone, Battery, Cpu, Power, Droplets, TrendingUp } from 'lucide-react';
import { services } from '../../data/mock';

const iconMap = {
  Smartphone: Smartphone,
  Battery: Battery,
  Cpu: Cpu,
  Power: Power,
  Droplets: Droplets,
  TrendingUp: TrendingUp
};

const ServicesSection = ({ brandName }) => {
  return (
    <section className="py-16 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-[#2B3990] mb-4">
            {brandName ? `Serviços para ${brandName}` : 'Nossos Serviços'}
          </h2>
          <p className="text-gray-600 max-w-2xl mx-auto">
            Oferecemos uma ampla gama de serviços de assistência técnica com peças de qualidade e garantia em todos os reparos.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {services.map((service) => {
            const IconComponent = iconMap[service.icon];
            return (
              <div 
                key={service.id}
                className="group p-6 bg-gray-50 rounded-xl hover:bg-[#2B3990] transition-all duration-300 hover:shadow-xl cursor-pointer"
              >
                <div className="w-14 h-14 bg-[#8DC63F]/20 rounded-lg flex items-center justify-center mb-4 group-hover:bg-[#8DC63F] transition-colors">
                  {IconComponent && <IconComponent size={28} className="text-[#8DC63F] group-hover:text-white transition-colors" />}
                </div>
                <h3 className="text-xl font-semibold text-[#2B3990] mb-2 group-hover:text-white transition-colors">
                  {service.name}
                </h3>
                <p className="text-gray-600 group-hover:text-gray-200 transition-colors">
                  {service.description}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;